import { useParams } from "react-router-dom";
import "./BiReport.css";
import { BI_REPORTS, getBiReportByAno } from "./biReportConfig";

const BiReport = () => {
  const { ano } = useParams<{ ano?: string }>();

  const report = getBiReportByAno(ano) || BI_REPORTS[0];

  return (
    <div className="bi-report-page">
      <iframe
        title={`BI Meritocracia ${report.ano}`}
        src={report.url}
        className="bi-report-iframe"
        frameBorder={0}
        allowFullScreen
      />
    </div>
  );
};

export default BiReport;
